<template>
  <div>
    <el-row :gutter="10">
      <el-col :span="10">
        <AllTable
          ref="allTable"
          :tableData="tableData"
          :loading="loading"
          @reload="reload"
          @checkbox-change="checkboxChange"
        >
          <page-header
            ref="header"
            slot="header"
            @query="getData"
            @reset="resetPage"
          />
        </AllTable>
      </el-col>
      <el-col :span="14">
        <CheckTable ref="checkTable" :tableData="checkRow" @remove="remove">
          <div class="d-flex align-items-center mb-1" slot="header">
            <div class="side-frame-success mr-2"></div>
            <div>
              <span style="font-size: 14px; color: #606266">
                {{ $l('table_head_tech_process') || '已选工艺' }}
              </span>
            </div>
          </div>
        </CheckTable>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import AllTable from './all-table.vue'
import CheckTable from './check-table.vue'
import PageHeader from './header'
import BaseTable from '@/mixins/base-table'
export default {
  mixins: [BaseTable],
  components: { PageHeader, AllTable, CheckTable },
  data() {
    return { checkRow: [], tableData: [] }
  },
  methods: {
    async getData(pdProcessDictFabricCode) {
      if (!pdProcessDictFabricCode) {
        this.tableData = []
        return
      }
      this.loading = true
      const res = await this.$api
        .processDictionaryTechListApi({ pdProcessDictFabricCode })
        .catch(() => null)
      if (res) {
        const data = res.body.data || []
        this.tableData = data.map((item) => ({
          ...item,
          unitPrice: item.labourCost,
        }))
      }
      this.loading = false
    },
    checkboxChange(data) {
      if (!data || data.length == 0) {
        this.checkRow = []
        return
      }
      const checkRow = data
        .map((m) => {
          return { ...m, processName: m.v_pdProcessDictStep }
        })
        .filter(
          (i) =>
            this.checkRow.findIndex(
              (j) => j.pdProcessDictTechCode === i.pdProcessDictTechCode
            ) < 0
        )
      this.checkRow.push(...checkRow)
      this.checkRow = this.checkRow.filter(
        (i) =>
          data.findIndex(
            (j) => j.pdProcessDictTechCode === i.pdProcessDictTechCode
          ) > -1
      )
      this.$emit('checkbox-change', this.checkRow)
      // setTimeout(() => {
      //   this.$refs.checkTable.sort('pdProcessDictStep', 'asc')
      // }, 0)
    },
    remove(data) {
      this.$refs.allTable.setCheckboxRow(data, false)
      const index = this.checkRow.findIndex((item) => {
        return item.pdProcessDictTechCode === data.pdProcessDictTechCode
      })
      if (index != -1) {
        this.checkRow.splice(index, 1)
      }
    },
    async validate() {
      return await this.$refs.checkTable.validate()
    },
    async getTableData() {
      return await this.$refs.checkTable.getTableData()
    },
  },
}
</script>
<style lang="scss" scoped>
.side-frame-success {
  border-left: 3px solid $color-success;
  height: 26px;
  margin: 0;
  padding: 0;
}
</style>
